import React from "react";
import MoreInfoButton from "../../components/buttons/MoreInfoButton";
import ArtworkImageLoader from "../../components/ArtworkImageLoader";
import { Artwork } from "../../types";

interface ArtworkImageSectionProps {
  artwork: Artwork | null;
  isDirectLink: boolean;
  onScrollToClick: () => void;
}

const ArtworkImageSection: React.FC<ArtworkImageSectionProps> = ({
  artwork,
  isDirectLink,
  onScrollToClick,
}) => {
  return (
    <div className="container h-screen mx-auto sticky top-0 -mt-8 w-2/3 flex flex-col justify-between">
      <div
        className="flex-grow-[8] py-8 flex justify-center mx-auto opacity-100 transition-opacity duration-300"
        style={{ height: "80%" }}
      >
        {artwork && isDirectLink && <ArtworkImageLoader artwork={artwork} />}
      </div>
      <div className="flex-grow-[2] flex justify-center">
        <MoreInfoButton
          className="bottom-16 select-none"
          onClick={onScrollToClick}
        />
      </div>
    </div>
  );
};

export default ArtworkImageSection;
